import {
    Vue, Component,
} from 'vue-property-decorator';

/**
 * Add Classes based on Props
 */
@Component
class Classes extends Vue {
    p: Array<string> = [
        'baseClass',
        'color',
        'icon',
        'size',
        'sharp',
        'rounded',
        'flat',
        'raised',
        'pill',
        'outline',
        'bordered',
        'block',
        'dense',
    ];

    colorValue = 'default';

    /**
     * Return the class of the component.
     *
     * @param {string} baseClass
     * @param {string} configClass
     * @returns {string}
     */
    componentClass(baseClass: string, configClass: string): string {
        return baseClass || configClass;
    }

    /**
     * Create classes array for the component.
     * 
     * @param {string} component - Component of the classes
     * @param {Array} props - List of props
     * @param {string} baseClass - Base Class of the component
     * @returns {Array} - Array of classes
     */
    commonClasses(component: string, props: Record<string, string>, baseClass: string): Array<string> {
        const classes: Array<string> = [];
        Object.entries(props).forEach(([key, value]) => {
            if (this.p.includes(key)) {
                if (key === 'baseClass') {
                    classes.push(value || baseClass);
                }

                if (key === 'color') {
                    this.colorValue = value;
                    classes.push(`is-color--${value}`);
                }

                if (key === 'outline') {
                    if (value) {
                        classes.push(`is-outline is-outline--${this.colorValue}`);
                    }
                }

                if (key === 'size') {
                    if (value) {
                        classes.push(`is-size--${value}`);
                    }
                }
                if (key === 'rounded') {
                    if (value) {
                        classes.push('is-rounded');
                    }
                }
                if (key === 'flat') {
                    if (value) {
                        classes.push('is-flat');
                    }
                }
                if (key === 'raised') {
                    if (value) {
                        classes.push('is-raised');
                    }
                }
                if (key === 'sharp') {
                    if (value) {
                        classes.push('is-sharp');
                    }
                }
                if (key === 'pill') {
                    if (value) {
                        classes.push('is-pill');
                    }
                }
                if (key === 'icon') {
                    if (value) {
                        classes.push('is-icon');
                    }
                }
                if (key === 'bordered') {
                    if (value) {
                        classes.push('is-bordered');
                    }
                }
                if (key === 'block') {
                    if (value) {
                        classes.push('is-block');
                    }
                }
                if (key === 'dense') {
                    if (value) {
                        classes.push('is-dense');
                    }
                }
            } else {
                console.error(`The prop ${key} in ${component} component is not common. Define it separately.`);
            }
        });

        return classes;
    }
}

export default Classes;
